import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { MDXRenderer } from 'gatsby-plugin-mdx';

const MarkdownRender = ({ md }) => {
  if (typeof md === 'object' && md.props) {
    return <ReactMarkdown source={md.props.value} />;
  }
  return <MDXRenderer>{md}</MDXRenderer>;
};

MarkdownRender.propTypes = {
  md: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
};

export default MarkdownRender;
